<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="search"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
    >
      <template
        slot-scope="scope" 
         slot="projectIdSearch"
      >
        <el-select
          v-model="query.projectId" 
          placeholder='请选择项目名称'
          clearable 
          @change="projectChange"
        >
          <el-option
            v-for="(item,index) in projectList"
            :key="index"
            :label="item.name"
            :value="item.id"
          >
            
          </el-option>
        </el-select>
      </template>
      <template
        slot-scope="scope" 
         slot="nameSearch"
      >
        <el-input v-model="query.name" placeholder="请输入任务名称"></el-input>
      </template>
      <template
        slot-scope="scope" 
         slot="objectTypeSearch"
      >
        <el-select
          v-model="query.objectType" 
          clearable 
          @change="objectTypeChange"
          placeholder='请选择考核对象'
        >
          <el-option
            v-for="(item,index) in objectTypeList"
            :key="index"
            :label="item.dictValue"
            :value="item.dictKey"
          >
            
          </el-option>
        </el-select>
      </template>
      <template
        slot-scope="scope" 
         slot="workStatusSearch"
      >
        <el-select
          v-model="query.workStatus" 
          clearable 
          placeholder='请选择任务状态'
          @change="workStatusChange"
        >
          <el-option
            v-for="(item,index) in workStatusList"
            :key="index"
            :label="item.dictValue"
            :value="item.dictKey"
          >
            
          </el-option>
        </el-select>
      </template>
      <template slot-scope="scope" slot="menu">
        <!-- <el-button icon="el-icon-check" size="small" type="text" @click="showTaskDetail()">任务详情</el-button> -->

        <!-- <el-button icon="el-icon-check" size="small" type="text" @click="editDetail()">查看</el-button>
    <el-button icon="el-icon-check" size="small" type="text" @click="editDetail()">编辑</el-button>
    <el-button icon="el-icon-check" size="small" type="text" @click="deleteDetail()">删除</el-button> -->
        
        <ViewBox
          :row.sync="scope.row"
          :query.sync="query"
          @refreshAction="onLoad()"
          v-if="getButtonShowFlag(scope.row.workStatus, 'view')"
        />
        <TaskDetailBox
          :row.sync="scope.row"
          v-if="getButtonShowFlag(scope.row.workStatus, 'task')"
        />
        <EditBox
          :row.sync="scope.row"
          :query.sync="query"
          @refreshAction="onLoad()"
          v-if="getButtonShowFlag(scope.row.workStatus, 'edit')"
        />
        <DeleteBox
          :row.sync="scope.row"
          @refreshAction="onLoad()"
          v-if="getButtonShowFlag(scope.row.workStatus, 'delete')"
        />
        <CloseBox
          :row.sync="scope.row"
          @refreshAction="onLoad()"
          v-if="getButtonShowFlag(scope.row.workStatus, 'close')"
        />
        <AnalysisDetailBox
          :row.sync="scope.row"
          :query.sync="query"
          v-if="getButtonShowFlag(scope.row.workStatus, 'analysis')"
        />
        <el-button
          @click="printAction(scope.row)"
          type="text"
          size="small"
          icon=""
            style="padding:0 .1rem"
          v-if="getButtonShowFlag(scope.row.workStatus, 'print')"
          >查看报告</el-button
        >
      </template>
      <template slot="menuLeft">
        <AddBox :query.sync="query" @refreshAction="onLoad()" />
        <!-- <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.assesstask_delete"
          @click="handleDelete"
          >删 除
        </el-button> -->
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getProjectDic,
} from '@/api/v4ward/assess/task/assesstask';
import { getProjectList } from '@/api/crmedical/group/group';
import { getDictionary } from '@/api/common';
import { mapGetters } from 'vuex';
import AnalysisDetailBox from './analyse';
import TaskDetailBox from './task';

import DeleteBox from './delete';
import EditBox from './edit';
import ViewBox from './view';
import AddBox from './add';
import CloseBox from './close';
import urlSettings from '@/config/url-settings.js';

export default {
  components: {
    AnalysisDetailBox,
    TaskDetailBox,
    DeleteBox,
    EditBox,
    ViewBox,
    AddBox,
    CloseBox,
  },
  data() {
    return {
      projectId: '1231331',
      form: {},
      query: {},
      search: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      projectList: [
        {
          id: '213131',
          name: 'adwwada',
        },
        {
          id: '657757',
          name: '12313ada',
        },
      ],
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 90,
        tip: false,
        border: true,
        index: true,
        viewBtn: false,
        selection: false,
        addBtn: false,
        delBtn: false,
        editBtn: false,
        column: [
          // {
          //   label: '主键',
          //   prop: 'id',
          //   rules: [
          //     {
          //       required: true,
          //       message: '请输入主键',
          //       trigger: 'change',
          //     },
          //   ],
          // },
          {
            // label: '项目id',
            label: '项目名称',
            prop: 'projectId',
            placeholder:'请选择项目名称',
            search: true,
            searchslot: true,
            searchValue: '',
            type: 'select',
            props: {
              label: 'name',
              value: 'id',
            },
            dicData: [],
            rules: [
              {
                required: true,
                message: '请输入项目名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '任务名称',
            prop: 'name',
            search: true,
            searchslot: true,
            type:'input',
            placeholder:'请输入任务名称',
            rules: [
              {
                required: true,
                message: '请输入任务名称',
                trigger: 'blur',
              },
            ],
          },
          {
            // label: "考核对象类型,取自项目字典project_assess_object_type",
            label: '考核对象',
            prop: 'objectType',
            searchslot: true,
            search: true,
            type: 'select',
            placeholder:'请选择考核对象',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicData: [],
            rules: [
              {
                required: true,
                // message: '请输入考核对象类型,取自项目字典project_assess_object_type',
                message: '请输入考核对象类型',
                trigger: 'change',
              },
            ],
          },
          {
            // label: '标准id',
            label: '标准名称',
            prop: 'standardId',
            hide: true,
            rules: [
              {
                required: true,
                // message: '请输入标准id',
                message: '请输入标准名称',
                trigger: 'change',
              },
            ],
          },
          {
            // label: '标准id',
            label: '标准名称',
            prop: 'standardName',
            rules: [
              {
                required: true,
                // message: '请输入标准id',
                message: '请输入标准名称',
                trigger: 'change',
              },
            ],
          },
          {
            // label: '关联合同id',
            label: '关联合同',
            prop: 'contractId',
            hide: true,
            rules: [
              {
                required: true,
                // message: '请输入关联合同id',
                message: '请输入关联合同',
                trigger: 'change',
              },
            ],
          },
          {
            label: '总分',
            prop: 'totalScore',
            rules: [
              {
                required: true,
                message: '请输入总分',
                trigger: 'change',
              },
            ],
          },
          {
            label: '基准分',
            prop: 'baseScore',
            rules: [
              {
                required: true,
                message: '请输入基准分',
                trigger: 'change',
              },
            ],
          },
          {
            label: '合同名称',
            prop: 'contractName',
            rules: [
              {
                required: true,
                // message: '请输入关联合同id',
                message: '请输入合同名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '合同编号',
            prop: 'contractCode',
            rules: [
              {
                required: true,
                // message: '请输入关联合同id',
                message: '请输入合同编号',
                trigger: 'change',
              },
            ],
          },
          {
            // label: '通知方式（多选）：1-系统消息；2-短信；3-微信；',
            label: '通知方式',
            prop: 'systemNotifyWays',
            hide: true,
            rules: [
              {
                required: true,
                // message: '请输入通知方式（多选）：1-系统消息；2-短信；3-微信；',
                message: '请输入通知方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '开始时间',
            prop: 'startTime',
            rules: [
              {
                required: true,
                message: '请输入开始时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '结束时间',
            prop: 'endTime',
            rules: [
              {
                required: true,
                message: '请输入结束时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '完成情况',
            prop: 'performance',
            rules: [
              {
                required: true,
                // message: '请输入任务状态 0-未开始 1-进行中 2-已完成 3-已关闭 系统字典assess_task_work_status',
                message: '请输入完成情况',
                trigger: 'change',
              },
            ],
          },
          {
            // label: '任务状态 0-未开始 1-进行中 2-已完成 3-已关闭 系统字典assess_task_work_status',
            label: '任务状态',
            prop: 'workStatus',
            searchslot: true,
            placeholder:'请选择任务状态',
            search: true,
            type: 'select',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicData: [],
            rules: [
              {
                required: true,
                // message: '请输入任务状态 0-未开始 1-进行中 2-已完成 3-已关闭 系统字典assess_task_work_status',
                message: '请输入任务状态',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
      workStatusList:[],
      objectTypeList:[],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        // addBtn: this.vaildData(this.permission.assesstask_add, false),
        // viewBtn: this.vaildData(this.permission.assesstask_view, false),
        // delBtn: this.vaildData(this.permission.assesstask_delete, false),
        // editBtn: this.vaildData(this.permission.assesstask_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    console.log(this.$refs.crud);
    getProjectList().then((res) => {
      console.log(res);
      this.projectList = res.data;
      this.query.projectId = res.data[0].id;
      this.setSearchFormValue('crud', 'projectId', res.data[0].id);
      this.setSearchFormDic('projectId', res.data);
      this.getDicData(res.data[0].id);
      this.onLoad();
    });
    // avue-form__menu
    this.setSearchFormStyle('crud', '.avue-form__menu', 'text-align:right;');
  },
  methods: {
    objectTypeChange(val){
      this.query.objectType = val;
      this.query = Object.assign({},this.query,{
        objectType:val
      })
    },
    workStatusChange(val){
      this.query.workStatus = val;
      this.query = Object.assign({},this.query,{
        workStatus:val
      })
    },
    projectChange(val){
      this.query.projectId = val;
      this.query = Object.assign({},this.query,{
        projectId:val,
        workStatus:'',
        objectType:''
      });
      this.getSearchDicData(val);
    },
    printAction(row) {
      let provideNum = row.performance.split('/')[1];
      let recoverNum = row.performance.split('/')[0];
      //打印方法...
      let path =
        urlSettings.VUE_APP_BASE_REPORT_URL +
        urlSettings.VUE_APP_ENVIRONMENT +
        '/assessTaskReport.cpt' +
        '&projectName=' +
        row.$projectId +
        '&taskName=' +
        row.name +
        '&serviceTypeName=' +
        row.$objectType +
        '&startTime=' +
        row.startTime +
        '&endTime=' +
        row.endTime +
        '&standardName=' +
        row.standardName +
        '&contractName=' +
        row.contractName +
        '&contractCode=' +
        row.contractCode +
        '&totalScore=' +
        row.totalScore +
        '&baseScore=' +
        row.baseScore +
        '&provideNum=' +
        provideNum +
        '&recoverNum=' +
        recoverNum +
        '&taskId=' +
        row.id;
      window.open(
        path,
        'newindow',
        'height=600,width=1100,top=100,left=100,toolbar=no,' +
          'menubar=no,scrollbars=no,resizable=no,location=no,status=no,z-look=yes'
      );
    },
    getButtonShowFlag(workStatus, buttonType) {
      // return true;
      if (buttonType === 'view' || buttonType === 'task') {
        return true;
      }
      if (parseInt(workStatus) == 0) {
        //未开始
        if (buttonType === 'delete' || buttonType === 'edit') {
          return true;
        } else {
          return false;
        }
      }
      if (parseInt(workStatus) == 1) {
        //进行中

        if (buttonType === 'close') {
          return true;
        } else {
          return false;
        }
      }
      if (parseInt(workStatus) == 2) {
        //已结束
        if (buttonType === 'analysis' || buttonType === 'print') {
          return true;
        } else {
          return false;
        }
      }
      if (parseInt(workStatus) == 3) {
        //已关闭
        if (buttonType === 'delete') {
          return true;
        } else {
          return false;
        }
      }
    },
    getTableDicData(projectId) {
      // getProjectDic({ projectId: projectId, code: 'project_examine_service_type' }).then((res) => {
        this.setSearchFormDic('objectType', this.objectTypeList);
        // this.objectTypeList = res.data;
      // });
      // getDictionary('assess_task_work_status').then((res) => {
        this.setSearchFormDic('workStatus', this.workStatusList);
        // this.workStatusList = res.data;
      // });
    },
    getSearchDicData(projectId) {
      getProjectDic({ projectId: projectId, code: 'project_examine_service_type' }).then((res) => {
        // this.setSearchFormDic('objectType', res.data);
        this.objectTypeList = res.data;
      });
      getDictionary('assess_task_work_status').then((res) => {
        // this.setSearchFormDic('workStatus', res.data);
        this.workStatusList = res.data;
      });
    },
    getDicData(projectId) {
      getProjectDic({ projectId: projectId, code: 'project_examine_service_type' }).then((res) => {
        this.setSearchFormDic('objectType', res.data);
        this.objectTypeList = res.data;
      });
      getDictionary('assess_task_work_status').then((res) => {
        this.setSearchFormDic('workStatus', res.data);
        this.workStatusList = res.data;
      });
    },
    setSearchFormDic(prop, list) {
      const column = this.findObject(this.option.column, prop);
      column.dicData = list;
    },
    setSearchFormValue(ref, prop, value) {
      setTimeout(() => {
        this.$refs[ref].$refs.headerSearch.$refs.form.form[prop] = value;
      });
    },
    setSearchFormStyle(refName, className, styleContent) {
      setTimeout(() => {
        this.$refs[refName].$refs.headerSearch.$el.querySelector(className).style = styleContent;
      });
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset(params, done) {
      // let tempProjectId = this.query.projectId;
      this.query = Object.assign({},this.query,{
        name:'',
        objectType:'',
        workStatus:''
      });
      // this.query.projectId = tempProjectId;
      console.log(params, done);
      this.getSearchDicData(this.query.projectId);
      this.setSearchFormValue('crud', 'projectId', this.query.projectId);
      this.onLoad();
    },
    searchChange(params, done) {
      // this.query = params;
      this.page.currentPage = 1;
      // this.form.projectId = '6666666';
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onLoad();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.onLoad();
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query))
        .then(({ data }) => {
          this.getTableDicData(this.query.projectId);
          this.page.total = data.total;
          this.data = data.records;
          this.data.map((item) => {
            item.workStatus = item.workStatus + '';
            item.objectType = item.objectType + '';
            return item;
          });
          // this.data = [];
          this.loading = false;
          this.selectionClear();
        })
        .catch((e) => {
          this.data = [
            {
              projectId: '123',
            },
          ];
          this.loading = false;
          this.selectionClear();
        });
    },
  },
};
</script>

<style>
</style>
